import { render, staticRenderFns } from "./LinkExpired.vue?vue&type=template&id=30e718a9&scoped=true&"
import script from "./LinkExpired.vue?vue&type=script&lang=js&"
export * from "./LinkExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e718a9",
  null
  
)

export default component.exports